module.exports = __webpack_public_path__ + "assets/img/teacher (64).c11d3a70.png";